import React from 'react'
import BlogPosts from '../components/BlogPosts'
import Footer from '../components/Footer'
import HeroSlider from '../components/HeroSlider'

const Blog = () => {
  return (
    <> 
    <HeroSlider />
    <BlogPosts />
    <Footer />
    </>
  )
}

export default Blog